module.exports = __webpack_public_path__ + "static/img/close.a640aebc.png";